<template>

  <div class="row">
    <div class="col-md-12">
      <h4>Files</h4>
    </div>
  </div>

  <hr class="mt-1" />

  <div class="row">
    <div class="col-md-12">
      <div id="form-group-forms">
        <table class="table table-bordered v-middle mb-0" ref="formsTable">
          <thead>
          <tr>
            <th class="w-50s text-center">
              <checkbox-list-toggler :ids="formIds">
              </checkbox-list-toggler>
            </th>
            <th class="w-250s">File Name</th>
            <th class="w-100s text-center">Date</th>
            <th>Form Name</th>
            <th>Description</th>
            <th class="w-50s text-center">Status</th>
            <th class="w-50s"></th>
          </tr>
          </thead>
          <tbody>

            <template v-if="forms.length > 0">
              <tr v-for="(form, index) in forms">
                <td class="text-center">
                  <checkbox-toggler :index="index" name="form_ids[]" :id="form.id">
                  </checkbox-toggler>
                </td>
                <td>
                  <p class="form-control-plaintext">{{ form.file_name }}</p>
                </td>
                <td>
                  <p class="form-control-plaintext text-center">{{ form.created_at }}</p>
                </td>
                <td>
                  <input type="text" class="form-control input-sm" data-field="name" :name="'forms[' + form.id + '][name]'" :value="form.name" placeholder="Form name...">
                </td>
                <td>
                  <input type="text" class="form-control input-sm" data-field="description" :name="'forms[' + form.id + '][description]'" :value="form.description" placeholder="Form description...">
                </td>
                <td>
                  <div class="switch">
                    <div class="onoffswitch">
                      <input type="checkbox" class="onoffswitch-checkbox" :id="'forms[' + form.id + '][status]'" :name="'forms[' + form.id + '][status]'" value="1" :checked="form.status">
                      <label class="onoffswitch-label my-0" :for="'forms[' + form.id + '][status]'">
                        <span class="onoffswitch-inner"></span>
                        <span class="onoffswitch-switch"></span>
                      </label>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-danger" title="Delete form" @click="deleteForm(form.id)"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </template>

            <tr v-else>
              <td colspan="7">
                <p class="form-control-plaintext">No files</p>
              </td>
            </tr>

          </tbody>
          <tfoot class="bg-muted">
          <tr data-row-type="add-forms">
            <td colspan="1" class="text-center">
              <form-bulk-modal
                :action="formBulkRoute"
                :operation="formBulkOperation">
                <button type="button" class="btn btn-sm btn-danger" data-action="delete-bulk-forms" title="Delete forms"
                        :disabled="nothingSelected()"
                        v-modal="'form-bulk-modal'">
                  <i class="fa fa-trash"></i>
                </button>
              </form-bulk-modal>
            </td>
            <td colspan="5">
              <p class="form-control-plaintext text-right">Add one or more forms to this group. To select multiple forms, hold down Shift or Ctrl (Cmd on Mac OS) key while selecting files to upload.</p>
            </td>
            <td class="text-center">
              <form-upload-modal :action-forms-upload="formUploadRoute"
                                 modal-id="formUploadModal"
                                 title="Upload one or more files"
                                 @uploaded="uploaded"
                                 :group-id="groupId">
                <button type="button" class="btn btn-sm btn-primary" v-modal="'formUploadModal'" title="Add forms"><i class="fa fa-plus"></i></button>
              </form-upload-modal>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>

  <template v-if="deletedIds.length > 0">
    <input v-for="deletedId in deletedIds" type="hidden" name="forms_delete[]" :value="deletedId"/>
  </template>

</template>

<script>
import { mapState } from 'pinia'
import { useCheckboxListStore } from "../../stores/checkboxList"

export default {

  props: {
    groupId: {type: Number, required: true},
    formUploadRoute: {type: String, required: true},
    formBulkRoute: {type: String, required: true},
    formBulkOperation: {type: String, required: true},
    initialForms: {type: Array, required: true},
  },

  data() {
    return {
      forms: this.initialForms,
      deletedIds: [],
    }
  },

  computed: {
    ...mapState(useCheckboxListStore, ['nothingSelected']),

    formIds() {
      return this.forms.map((form) => form.id);
    }

  },

  methods: {

    uploaded(files) {
      files.forEach(file => this.forms.push(file));
    },

    deleteForm(formId) {
      this.deletedIds.push(formId);
      this.forms = this.forms.filter((form) => form.id !== formId);
    }

  }
}
</script>
